import { render, staticRenderFns } from "./TravelsTable.vue?vue&type=template&id=ae434054&"
import script from "./TravelsTable.vue?vue&type=script&lang=js&"
export * from "./TravelsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports